import { FC } from 'react';
import { SurrogateInvitationScreenProps } from './SurrogateInvitationScreen.interface';
import { SurrogateInvitationForm } from '@nodal/core/flows/SignUp/SurrogateInvitationForm';

export const SurrogateInvitationScreen: FC<SurrogateInvitationScreenProps> = ({
  initialValues,
  onSubmit,
  title,
  validationSchema,
  description,
}) => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <h2 className="mt-6 text-2xl font-semibold leading-8 text-gray-900 sm:text-3xl sm:font-bold sm:leading-9">
          {title}
        </h2>
        <p className="text-base font-normal leading-6 text-grey-forest-600 sm:text-lg sm:leading-7">
          {description}
        </p>
      </div>

      <div>
        <SurrogateInvitationForm
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        />
      </div>
    </>
  );
};
